module.exports = __webpack_public_path__ + "static/una_sketch-f89e85fa098cde168d659e9d5eb42797.jpg";